export default __webpack_public_path__ + "static/ios-logo-3-e3e7d96af793687f62a709ea92793579.webp";